import React, { useState, useEffect } from "react";
import { Loader } from "./components/common/Loader";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Hero } from "./components/sections/Hero";
import { Stats } from "./components/sections/Stats";
import { About } from "./components/sections/About";
import { Services } from "./components/sections/Services";
import { Projects } from "./components/sections/Projects";
import { Gallery } from "./components/sections/Gallery";
import { Testimonials } from "./components/sections/Testimonials";
import { Founder } from "./components/sections/Founder";
import { Timeline } from "./components/sections/Timeline";
import { Contact } from "./components/sections/Contact";
import { MapSection } from "./components/sections/MapSection";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="App selection:bg-nestlent-green selection:text-white">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <About />
        <Services />
        <Projects />
        <Gallery />
        <Testimonials />
        <Timeline />
        <MapSection />
        {/* <Founder /> */}
        {/* <Contact /> */}
      </main>
      <Footer />
    </div>
  );
}

export default App;
